const activeLabelStyles = {
    transform: 'scale(0.85) translateY(-24px)',
    color: 'black'
}

const activeLabelStylesProfile = {
    transform: 'scale(0.85) translateY(-14px)',
    color: 'black',
    fontSize: 'xs',
    lineHeight: 'normal'
}

const disabledLabelStyles = {
    transform: 'scale(0.85) translateY(-14px)',
    color: 'gray.700'
}

export default {
    variants: {
        floating: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...activeLabelStyles
                },
                '&:has(input:-webkit-autofill) label': {
                    ...activeLabelStyles
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...activeLabelStyles
                    },
                label: {
                    top: 0,
                    left: 0,
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700'
                }
            }
        },
        floatingGrayed: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...disabledLabelStyles
                },
                '&:has(input:-webkit-autofill) label': {
                    ...disabledLabelStyles
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...disabledLabelStyles
                    },
                label: {
                    fontSize: 'xs',
                    top: '6px',
                    left: '4px',
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700',
                    lineHeight: 'normal'
                },
                input: {
                    height: '50px',
                    fontSize: 'md',
                    paddingLeft: '4px',
                    paddingTop: '10px'
                }
            }
        },
        floatingProfileForm: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...activeLabelStylesProfile
                },
                '&:has(input:-webkit-autofill) label': {
                    ...activeLabelStylesProfile
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...activeLabelStylesProfile
                    },
                label: {
                    fontSize: 'md',
                    top: '6px',
                    left: '4px',
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700',
                },
                input: {
                    height: '50px',
                    fontSize: 'md',
                    paddingLeft: '4px',
                    paddingTop: '10px'
                }
            }
        },
        webFloatingField: {
            container: {
                position: 'relative',
                width: '100%',
                // Label: acts as placeholder when input is empty and not focused
                label: {
                    position: 'absolute',
                    top: '14px',
                    left: '9px',
                    zIndex: 2,
                    pointerEvents: 'none',
                    mb: 0,
                    textStyle: 'bodySmRegular',
                    color: 'webTypo.textTertiary',
                    transformOrigin: 'left top',
                    transition: 'all 0.15s ease-in-out'
                },
                // Float label up when focused
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    top: '4px',
                    left: '9px',
                    textStyle: 'bodyXsRegular',
                    color: 'webTypo.textSecondary'
                },
                // Float label up on autofill
                '&:has(input:-webkit-autofill) label': {
                    top: '4px',
                    left: '9px',
                    textStyle: 'bodyXsRegular',
                    color: 'webTypo.textSecondary'
                },
                // Float label up when input has a value
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        top: '4px',
                        left: '9px',
                        textStyle: 'bodyXsRegular',
                        color: 'webTypo.textSecondary'
                    },
                // Error state: label turns red
                '&[data-invalid] label': {
                    color: 'webTypo.textError'
                },
                "&[data-invalid]:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        color: 'webTypo.textError'
                    },
                '&[data-invalid]:has(input:focus, select:focus, textarea:focus) label': {
                    color: 'webTypo.textError'
                },
                '& label .web-field-suffix': {
                    textStyle: 'bodySmRegular',
                    color: 'webTypo.textPrimary'
                },
                '& label .web-field-optional': {
                    textStyle: 'bodySmRegular',
                    color: 'webTypo.textTertiary'
                },
                // Disabled state: label turns gray
                '&:has(input:disabled, select:disabled, textarea:disabled) label': {
                    color: 'webTypo.textDisabled'
                },
                '&:has(input:disabled, select:disabled, textarea:disabled) label .web-field-suffix': {
                    color: 'webTypo.textDisabled'
                },
                '&:has(input:disabled, select:disabled, textarea:disabled) label .web-field-optional': {
                    color: 'webTypo.textDisabled'
                }
            }
        },
        webFloatingFieldTextArea: {
            container: {
                position: 'relative',
                width: '100%',
                // Label: acts as placeholder when textarea is empty and not focused
                label: {
                    position: 'absolute',
                    top: '14px',
                    left: '9px',
                    zIndex: 2,
                    pointerEvents: 'none',
                    mb: 0,
                    textStyle: 'bodySmRegular',
                    color: 'webTypo.textTertiary',
                    transformOrigin: 'left top',
                    transition: 'all 0.15s ease-in-out'
                },
                // Float label up when focused
                '&:has(textarea:focus) label': {
                    top: '4px',
                    left: '9px',
                    textStyle: 'bodyXsRegular',
                    color: 'webTypo.textSecondary'
                },
                // Float label up when textarea has a value
                '&:has(textarea:not(:placeholder-shown)) label': {
                    top: '1px',
                    left: '9px',
                    textStyle: 'bodyXsRegular',
                    color: 'webTypo.textSecondary',
                    backgroundColor: 'webTheme.backgroundDefault',
                    width: 'calc(100% - 25px)'
                },
                // Error state: label turns red
                '&[data-invalid] label': {
                    color: 'webTypo.textError'
                },
                '&[data-invalid]:has(textarea:not(:placeholder-shown)) label': {
                    color: 'webTypo.textError'
                },
                '&[data-invalid]:has(textarea:focus) label': {
                    color: 'webTypo.textError'
                },
                '& label .web-field-suffix': {
                    textStyle: 'bodyXsRegular',
                    color: 'webTypo.textPrimary'
                },
                '& label .web-field-optional': {
                    textStyle: 'bodySmRegular',
                    color: 'webTypo.textTertiary'
                },
                // Disabled state: label turns gray
                '&:has(textarea:disabled) label': {
                    color: 'webTypo.textDisabled'
                },
                '&:has(textarea:disabled) label .web-field-suffix': {
                    color: 'webTypo.textDisabled'
                },
                '&:has(textarea:disabled) label .web-field-optional': {
                    color: 'webTypo.textDisabled'
                }
            }
        }
    }
}
